import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getOtellConType = (otellConTypeId: number | undefined): Promise<IGetOtellConType> => {
  return axiosDefaultApi.get(`/api/OteIIConTypes/GetOteIIConTypeViaID/${otellConTypeId}`);
};

type QueryFnType = typeof getOtellConType;

type UseGetOtellConTypeOptions = {
  otellConTypeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetOtellConType = ({ otellConTypeId , config }: UseGetOtellConTypeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getOtellConType_${otellConTypeId}`],
    queryFn: () => getOtellConType(otellConTypeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους τηλεπ. γραμμής ΟΤΕ`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};